var exports = {
  "kL": "ChannelWebhooksTab.module__container___NGFKVH",
  "wx": "ChannelWebhooksTab.module__header___NGFKVH",
  "h_": "ChannelWebhooksTab.module__description___NGFKVH",
  "UD": "ChannelWebhooksTab.module__buttonContainer___NGFKVH",
  "dc": "ChannelWebhooksTab.module__spinnerContainer___NGFKVH",
  "Xb": "ChannelWebhooksTab.module__messageBox___NGFKVH",
  "PQ": "ChannelWebhooksTab.module__webhooksList___NGFKVH",
  "wp": "ChannelWebhooksTab.module__followedSection___NGFKVH",
  "Gf": "ChannelWebhooksTab.module__sectionTitle___NGFKVH",
  "yV": "ChannelWebhooksTab.module__sectionDescription___NGFKVH",
};

module.exports = exports;
